/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScorecardFillCreateValues } from './scorecardFillCreateValues';

export interface ScorecardFillCreate {
  scorecard_definition_id: string;
  event_kind?: 'manual';
  /**
     * @minLength 1
     * @maxLength 120
     */
  external_event_id: string;
  values?: ScorecardFillCreateValues;
  submit?: boolean;
}
